import certificateOperationPrint from "@/api/academic/certificate-operation-print";

import { baseState, baseMutations } from "@/store/mixins";
import { split } from "lodash";

export const state = {
  ...baseState,
  formViewDatas: [],
  approveDatas: [],
};

export const getters = {};

export const mutations = {
  ...baseMutations,
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach((el) => {
        state.formViewDatas[el] = data[el];
      });
    }
  },
  SET_APPROVE_REQUEST(state, { data, index }) {
    if (!index) {
      state.approveDatas = data;
    } else {
      split(index, ",").forEach((el) => {
        state.approveDatas[el] = data[el];
      });
    }
  },
};

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
        },
      },
      attrubutes
    );
    return certificateOperationPrint.get({ params }).then((response) => {
      context.commit("RECEIVE_RESOURCES", response);
      return Promise.resolve(response);
    });
  },
  store(context, data) {
    return certificateOperationPrint.store(data);
  },
  update(context, { id, data }) {
    return certificateOperationPrint.update(id, data);
  },
  certificateOperationPrintApprove(context, { id, data }) {
    return certificateOperationPrint.certificateOperationPrintApprove(id, data);
  },
  reachCandidate(context, { id, data }) {
    return certificateOperationPrint.reachCandidate(id, data);
  },
  async approve(context, { params, index }) {
    let response = await certificateOperationPrint.approve({ params: params });
    await context.commit("SET_APPROVE_REQUEST", {
      data: response.data,
      index: index,
    });
    return Promise.resolve(response);
  },
  destroy(context, id) {
    return certificateOperationPrint.destroy(id);
  },
  async getFormViewData(context, { params, index }) {
    let response = await certificateOperationPrint.formModel({
      params: params,
    });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index,
    });
    return Promise.resolve(response);
  },
  printPdf(context, attribute = {}) {
    return certificateOperationPrint.printPdf({ params: attribute });
  },
};
